















import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import NoticesComposer from '@/pages/notices/NoticesComposer.vue'
import { Getter} from 'vuex-class'
import {IComposer, IRecipient} from "@/entities/notices"
import BaseCard from '@/components/BaseCard.vue'
import Loading from '@/components/Loading.vue'

@Component<InsightsNoticesComposer>({
    components: {
        NoticesComposer,
        BaseCard,
        Loading
    }
})
export default class InsightsNoticesComposer extends Vue {
    @Prop({ type: Boolean, required: true })
    readonly show!: boolean

    @Prop({ type: String, default: 'type' })
    readonly startStep!: string

    @Prop({ type: Object, default: () => ({}) })
    readonly notice!: object


    @Getter private composer !: IComposer
    @Getter private recipients!: IRecipient[]
    @Getter private loadingNoticesComposer!: boolean
}
